// apps/web/src/lib/brand-keys.ts
//
// LAT-1162 — web mirror of the server BrandKey union. Keep this list in sync
// with apps/mcp/src/core/policy/model-brand.ts.

export const BRAND_KEYS = [
  "anthropic",
  "claude",
  "cloudflare",
  "cohere",
  "cursor",
  "deepseek",
  "gemini",
  "gemma",
  "github",
  "google",
  "google-drive",
  "grok",
  "linear",
  "meta",
  "microsoft",
  "mistral",
  "model",
  "notion",
  "openai",
  "perplexity",
  "qwen",
  "slack",
] as const;

export type BrandKey = (typeof BRAND_KEYS)[number];

// Audit/client identities rendered by BrandGlyph but not returned by the model
// or connector APIs. Keeping these separate preserves BRAND_KEYS as the exact
// server mirror while allowing the shared glyph primitive to identify agents.
export const AGENT_BRAND_KEYS = ["hermes", "openclaw", "pi"] as const;

export type AgentBrandKey = (typeof AGENT_BRAND_KEYS)[number];

export const CHANNEL_BRAND_KEYS = ["whatsapp"] as const;

export const BRAND_GLYPH_KEYS = [
  ...BRAND_KEYS,
  ...AGENT_BRAND_KEYS,
  ...CHANNEL_BRAND_KEYS,
] as const;

export type BrandGlyphKey = (typeof BRAND_GLYPH_KEYS)[number];

// LAT-1996 — narrow a SERVER-supplied brand key. The catalog stamps the key,
// so the browser keeps no per-integration map; a key this bundle does not know
// falls to the neutral tile rather than rendering someone else's mark.
export function asBrandGlyphKey(value: string): BrandGlyphKey {
  return (BRAND_GLYPH_KEYS as readonly string[]).includes(value)
    ? (value as BrandGlyphKey)
    : "model";
}
